<app-header-simple></app-header-simple>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">
  
  
      <!-- Titulo -->
      <div class="carousel-item active">
        <div class="carousel-container" style="height: 100%;">
          <h2 class="mt-4 animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
            Detalles del Pago
          </h2>
  
          <section id="services" class="services" style="padding: 1rem;width: 100%;">
            <p>{{quiniela.datos_de_pago}}</p>
  
            <h4 class="text-white"><i class="icofont-email" style="color: white;font-size: 24px;"></i> Email:</h4>
            <p>{{quiniela.email}}</p>
            <h4 class="text-white"><i class="icofont-phone" style="color: white;font-size: 24px;"></i> Teléfono:</h4>
            <p>{{quiniela.telefono}}</p>
  
            <a routerLink="/{{ quiniela.url }}"
              class="btn-get-started animate__animated animate__faster animate__fadeInDown"
              style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;width: 150px;">
              Volver
            </a>
          </section>
        </div>
      </div>
  
    </div>
  
  
    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 24 150 28 " preserveAspectRatio="none">
      <defs>
        <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
      </defs>
      <g class="wave1">
        <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
      </g>
      <g class="wave2">
        <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
      </g>
      <g class="wave3">
        <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
      </g>
    </svg>